import {
  UserCheck,
  ClipboardList,
  FileCheck2,
  ScanLine,
  ShieldCheck,
  Files,
} from 'lucide-react';
import SectionHeading from './SectionHeading';

const records = [
  { icon: UserCheck, label: 'Lista de asistencia' },
  { icon: FileCheck2, label: 'Firmas de supervisión' },
  { icon: ClipboardList, label: 'Registros de servicio' },
  { icon: ScanLine, label: 'Seguimiento del personal' },
  { icon: Files, label: 'Clasificación de productos' },
  { icon: ShieldCheck, label: 'Hojas de seguridad' },
];

const Records = () => {
  return (
    <section className="bg-slate-50 py-24">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <SectionHeading
          center
          eyebrow="Control documentado"
          title="REGISTROS"
          text="Seguimiento del servicio y anexos para una operación organizada, verificable y segura."
        />

        <div className="mt-12 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {records.map((record) => {
            const Icon = record.icon;
            return (
              <div
                key={record.label}
                className="flex items-center gap-5 border border-slate-200 bg-white p-6"
              >
                <div className="grid h-12 w-12 shrink-0 place-items-center bg-[#0A2540] text-[#00a7e2]">
                  <Icon size={22} />
                </div>
                <h3 className="font-bold uppercase text-[#0A2540]">
                  {record.label}
                </h3>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Records;